import React, { useState } from "react";
import { Sonho } from "../../types";
import { CModal } from "../data-display";

import AddIcon from "@mui/icons-material/Add";
import { IconButton } from "@mui/material";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { storage } from "../../lib/cliente";
import { useSonho } from "../../services/sonhos";
import { memoObserver } from "../../utils/memoObserver.utils";
import { FormSonho, FormSonhoRef } from "./form-sonhos.component";

export const ModalFormSonho = memoObserver(() => {
  const { addSonho } = useSonho();
  const formRef = React.useRef<FormSonhoRef>(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (values: Sonho) => {
    try {
      const files = formRef?.current?.getFiles();
      setLoading(true);
      if (files) {
        const uploadPromises: Promise<string>[] = files.map(
          async (file: any | Blob) => {
            return new Promise<string>((resolve, reject) => {
              if (!file.status) {
                const uniqueFileName = uuidv4() + "-" + file.name;
                const fileRef = ref(storage, `images/${uniqueFileName}`);
                const uploadTask = uploadBytesResumable(fileRef, file);
                uploadTask.on(
                  "state_changed",
                  null,
                  (error) => reject(error),
                  async () => {
                    try {
                      const url = await getDownloadURL(uploadTask.snapshot.ref);
                      resolve(url);
                    } catch (error) {
                      reject(error);
                    }
                  }
                );
              } else {
                resolve(file.url);
              }
            });
          }
        );
        const resolvedUrls = await Promise.all(uploadPromises);

        const newItem = {
          ...values,
          imagesUrl: resolvedUrls,
        };

        await addSonho(newItem);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton onClick={() => setOpen(true)}>
        <AddIcon />
      </IconButton>
      <CModal
        title="Novo Pacote"
        onSave={() => {
          formRef.current?.submit();
          handleClose();
        }}
        open={open}
        onClose={() => handleClose()}
        loading={loading}
      >
        <FormSonho ref={formRef} onSubmit={onSubmit} />
      </CModal>
    </>
  );
});
